import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { useSite } from "@/context/SiteContext";
import { FadeUp, SectionHeading } from "@/components/Reveal";

const FAQ = () => {
    const { content } = useSite();
    const { faq } = content;

    return (
        <section id="faq" data-testid="faq-section" className="bg-mist py-20 sm:py-28">
            <div className="mx-auto max-w-3xl px-4 sm:px-6 lg:px-8">
                <SectionHeading eyebrow="FAQ" heading={faq.heading} />

                <FadeUp delay={0.1}>
                    <Accordion type="single" collapsible className="mt-12 space-y-3">
                        {faq.items.map((item, i) => (
                            <AccordionItem
                                key={item.q}
                                value={`faq-${i}`}
                                data-testid={`faq-item-${i}`}
                                className="rounded-xl border border-slate-200 bg-white px-6 shadow-sm"
                            >
                                <AccordionTrigger
                                    data-testid={`faq-trigger-${i}`}
                                    className="py-5 text-left font-display text-base font-bold text-navy hover:no-underline sm:text-lg"
                                >
                                    {item.q}
                                </AccordionTrigger>
                                <AccordionContent data-testid={`faq-content-${i}`} className="pb-5 text-sm leading-relaxed text-slate-600 sm:text-base">
                                    {item.a}
                                </AccordionContent>
                            </AccordionItem>
                        ))}
                    </Accordion>
                </FadeUp>
            </div>
        </section>
    );
};

export default FAQ;
